import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { BadgesService } from '../../services/badges';
import { CoinsService } from '../../services/coins';
import { UsersService } from '../../services/user';
import InputMask from 'react-input-mask';
import { Utils } from '../../utils/utils';
import './recuperar-senha.css';

import {
  ContentHeader,
  CoinsBox,
  BadgesBox,
  BackBtn
} from '../../components';

export default class ViewRecuperarSenha extends Component {
  constructor(props) {
    super(props);

    this.emailRef = React.createRef();

    this.state = {
      "render_preloader": false,
      "render_login_error": false,
      "render_success_message": false,
      "field_email": "",
      "signin_in": false
    }
  }

  componentDidMount() {
  }

  componentWillMount() {
    var user = UsersService.getUser();
    if (user !== null) {
      window.location = window.location.origin + window.location.pathname + "#/feed";
    }
  }

  async signIn() {
    var _this = this;
    var directory = Sdk.Api.authorization.activeDirectory.uid;
    var email = this.state.field_email;

    _this.setState({
      "signin_in": true
    });
    

    try {
      var reset = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/password/forgot/directory/uid/${directory}?email=${email}`, null, 'POST');
      _this.setState({
        "signin_in": false,
        "render_success_message": true
      });
    } catch (e) {
      _this.setState({
        "render_login_error": true,
        "signin_in": false
      })
    }
    

  // https://api.digitalpages.com.br/auth/v1.0/user/password/forgot/directory/uid/9161fd18-9430-ee11-b8f0-6045bd399b6d?email=mohamad.saad@euconquisto.com
  }

  onChangeEmail(val) {
    this.setState({
      "field_email": val.toLowerCase()
    });
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    var _this = this;
    const {
      render_preloader,
      render_login_error,
      render_success_message,
      field_email
    } = this.state;

    return <div className="rdp-react-template-view-recuperar-senha">
      <div style={{paddingLeft: "25px", paddingTop: "25px"}}>
        {/* <BackBtn
          onClick={() => this.redirectTo("/")}
        /> */}
      </div>
      <div className="rdp-react-template-view-recuperar-senha-header">
        <span className="rdp-react-template-view-recuperar-senha-header-logo"></span>
      </div>
      {render_preloader &&
        <div className="rdp-react-template-view-recuperar-senha-preloader">
          <div className="rdp-react-template-view-recuperar-senha-preloader-loader"></div>
        </div>
      }

      {render_login_error &&
        <div className="rdp-react-template-view-recuperar-senha-error">
          <div className="rdp-react-template-view-recuperar-senha-error-box">
            <span className="rdp-react-template-view-recuperar-senha-error-box-icon"></span>
            <h1 className="rdp-react-template-view-recuperar-senha-error-box-title">E-mail não encontrado!</h1>
            <p className="rdp-react-template-view-recuperar-senha-error-box-message">
              Verifique se as informações estão corretas e <br></br>tente novamente.
            </p>
            <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.setState({"render_login_error": false})}>Voltar</button>
          </div>
        </div>
      }

      <div className="rdp-react-template-view-recuperar-senha-content">
        <span className="rdp-react-template-view-recuperar-senha-title">Primeiro acesso ou recuperação de senha</span>

        {render_success_message &&
          <>
            <span className="rdp-react-template-view-recuperar-senha-success-message">
              Um e-mail foi enviado para <b>{field_email}</b> com orientações para redefinir sua senha.
            </span>
            <div class="rdp-component-btn-group-flex">
              <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.setState({"render_success_message": false})}>Voltar</button>
            </div>
          </>
        }

        {!render_success_message &&
          <>
            <input
              ref={this.emailRef}
              className="rdp-react-template-view-recuperar-senha-input"
              type="text"
              placeholder="Digite seu e-mail cadastrado"
              value={this.state.field_email}
              onChange={(e) => this.onChangeEmail(e.target.value)}
            ></input>
            <div class="rdp-component-btn-group-flex">
              <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.redirectTo("/")}>Voltar</button>
              <button className="rdp-component-btn primary position-right icon-right" onClick={() => this.signIn()}>{this.state.signin_in ? "Aguarde..." : "Enviar e-mail"}</button>
            </div>
          </>
        }
      </div>
      {/* Um e-mail foi enviado para mohamad.onil@euconquisto.com com orientações para redefinir sua senha. */}
    </div>;
  }
}
